import React from 'react'
import { SignFormStep1 } from '@shared/components/forms/sign/steps/step1/form'

export const View = () => <SignFormStep1 />
